<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="template !== null" role="form">

    <div class="p-grid">
        <div class="p-col-6">
          <h2>{{ t('common.labels.basedata') }}</h2>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit !== true">
          <button withRight="admin.template.edit" pButton (click)="onEdit()" type="button" label="{{ t('common.labels.edit') }}" icon="pi pi-pencil" class="p-button-sm p-mb-2 autofocus"></button>
          <button withRight="admin.ac.create" pButton (click)="onCreateAc()" type="button" label="{{ t('common.labels.create_ac') }}" icon="pi pi-file" class="p-button-sm p-button-success p-mb-2 p-ml-2"></button>
          <button *ngIf="items.length > 0" pButton type="button" (click)="menu.toggle($event)" icon="pi pi-bars" class="p-button-outlined p-button-secondary p-button-sm p-mb-2 p-ml-2" aria-label="{{ t('common.labels.more_functions') }}"></button>
          <p-menu #menu [popup]="true" [model]="items"></p-menu>
        </div>
        <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
          <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
        </div>
    </div>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'name'" [control]="form.get('name')" [type]="'input'" [label]="t('common.labels.name')" [edit]="inEdit" [basevalue]="template.name"></app-form-control>
        <app-form-control [cid]="'language'" [control]="form.get('language')" [type]="'select'" [options]="languages" [label]="t('common.labels.language')" [edit]="inEdit" [basevalue]="t(template.getLanguageName())"></app-form-control>
        <app-form-control [cid]="'template_category'" [control]="form.get('template_category')" [type]="'select'" [options]="optionsCategories" [label]="t('common.labels.category')" [edit]="inEdit" [basevalue]="template.template_category" [editable]="true"></app-form-control>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'ratingtype'" [control]="form.get('ratingtype')" [type]="'select'" [options]="ratingtypes" [optionLabel]="'name.' + transloco.getActiveLang().toUpperCase()" [label]="t('common.labels.ratingtype')" [edit]="inEdit" [basevalue]="template.ratingtype?.getLang('name', transloco.getActiveLang())"></app-form-control>
        <app-form-control [cid]="'type'" [control]="form.get('type')" [type]="'select'" [options]="types" [label]="t('common.labels.type')" [edit]="inEdit" [basevalue]="t('common.labels.' + template.type + '_ac')"></app-form-control>
        <app-form-control [cid]="'breakafter'" [control]="form.get('breakafter')" [type]="'input'" [label]="t('ac_basedata.breakafter')" [edit]="inEdit" [basevalue]="template.breakafter"></app-form-control>
      </div>
    </div>

    <hr>

    <h2>{{ t('common.labels.locations') }}</h2>

    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <div class="p-grid">
          <div class="p-col-6"><app-form-control [cid]="'onsite'" [control]="form.get('onsite')" [type]="'checkbox'" [label]="t('common.labels.onsite')" [edit]="inEdit" [basevalue]="template.onsite"></app-form-control></div>
          <div class="p-col-6"><app-form-control [cid]="'virtual'" [control]="form.get('virtual')" [type]="'checkbox'" [label]="t('common.labels.virtual')" [edit]="inEdit" [basevalue]="template.virtual"></app-form-control></div>
        </div>
      </div>
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'locations'" [control]="form.get('locations')" [type]="'multiselect'" [label]="t('common.labels.locations')" [edit]="inEdit" [basevalue]="getLocationNames().join(', ')" [options]="optionsLocations" [optionLabel]="'name'" [dataKey]="'id'"></app-form-control>
      </div>
    </div>

    <hr>

    <h2>{{ t('common.labels.settings') }}</h2>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'documents_visible_observer'" [control]="form.get('documents_visible_observer')" [type]="'checkbox'" [label]="t('ac_basedata.documents_visible_observer')" [edit]="inEdit" [basevalue]="template.documents_visible_observer"></app-form-control>
        <hr>
        <div [withFeature]="'templates.tags'">
          <app-form-control [cid]="'tags'" [control]="form.get('tags')" [type]="'chips'" [label]="t('common.labels.tags')" [edit]="inEdit" [basevalue]="template.tags | arrayToList"></app-form-control>
          <p class="p-text-small" *ngIf="inEdit"><i class="pi pi-exclamation-circle p-mr-2"></i>{{ t('ac_basedata.tags_hint') }}</p>
          <app-form-control [cid]="'tags_required'" [control]="form.get('tags_required')" [type]="'checkbox'" [label]="t('common.labels.tags_required')" [edit]="inEdit" [basevalue]="template.tags_required"></app-form-control>

          <app-form-control [cid]="'tag_label_de'" [control]="form.get('tag_label.DE')" [type]="'input'" [label]="t('common.labels.label') + '(DE)'" [edit]="inEdit" [basevalue]="template.tag_label?.['DE']"></app-form-control>
          <app-form-control [cid]="'tag_label_en'" [control]="form.get('tag_label.EN')" [type]="'input'" [label]="t('common.labels.label') + '(EN)'" [edit]="inEdit" [basevalue]="template.tag_label?.['EN']"></app-form-control>
          <app-form-control [cid]="'tag_label_de'" [control]="form.get('tag_description.DE')" [type]="'textarea'" [label]="t('common.labels.description') + '(DE)'" [edit]="inEdit" [basevalue]="template.tag_description?.['DE']"></app-form-control>
          <app-form-control [cid]="'tag_label_en'" [control]="form.get('tag_description.EN')" [type]="'textarea'" [label]="t('common.labels.description') + '(EN)'" [edit]="inEdit" [basevalue]="template.tag_description?.['EN']"></app-form-control>
        </div>
        <!--  -->
        <hr>
        <app-form-control [cid]="'short'" [control]="form.get('short')" [type]="'checkbox'" [label]="t('ac_basedata.short')" [edit]="inEdit" [basevalue]="template.short"></app-form-control>
        <div *ngIf="isShort()">
          <app-form-control [cid]="'starttimes'" [control]="form.get('starttimes')" [type]="'chips'" [label]="t('ac_basedata.starttimes')" [edit]="inEdit" [basevalue]="template.starttimes | arrayToList"></app-form-control>
          <p class="p-text-small" *ngIf="inEdit"><i class="pi pi-exclamation-circle p-mr-2"></i>{{ t('ac_basedata.starttimes_hint') }}</p>
        </div>
      </div>
      <div class="p-col-12 p-md-6 p-field-acr">
        <label for="mailtext">{{ t('common.labels.additional_mailtext') }}</label>
        <div class="p-inputgroup" *ngIf="inEdit">
          <editor style="width: 100%" [formControl]="form.get('mailtext')" [init]="getEditorInit()" [class.editor-error]="form.get('mailtext').invalid && form.get('content').dirty"></editor>
          <app-form-error [control]="form.get('mailtext')" [label]="t('common.labels.mailtext')"></app-form-error>
        </div>
        <ng-container *ngIf="!inEdit">
          <div *ngIf="template.mailtext" [innerHtml]="template.mailtext"></div>
          <div *ngIf="!template.mailtext">-</div>
        </ng-container>
      </div>
    </div>

    <hr>

    <h2>{{ t('common.labels.aireport') }}</h2>
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6">
        <app-form-control [cid]="'report'" [control]="form.get('aireport.report')" [type]="'select'" [options]="reportTemplates" optionLabel="public_name" [label]="t('ac_basedata.report_template')" [edit]="inEdit" [basevalue]="template.aireport?.public_name"></app-form-control>
      </div>
      <div class="p-col-12 p-md-3 p-field-acr">
        <app-form-control [cid]="'threshold_negative'" [control]="form.get('aireport.threshold_negative')" [type]="'input'" [label]="t('ac_basedata.threshold_negative')" [edit]="inEdit" [basevalue]="template.aireport_settings?.threshold_negative"></app-form-control>
      </div>
      <div class="p-col-12 p-md-3 p-field-acr">
        <app-form-control [cid]="'threshold_positive'" [control]="form.get('aireport.threshold_positive')" [type]="'input'" [label]="t('ac_basedata.threshold_positive')" [edit]="inEdit" [basevalue]="template.aireport_settings?.threshold_positive"></app-form-control>
      </div>
    </div>

  </form>

  <app-inherit-dialog
    [title]="t('common.labels.save')"
    [mode]="'template'"
    [(visible)]="inheritVisible"
    (okClicked)="saveForm($event)"
  ></app-inherit-dialog>
</ng-container>
